module.exports = __webpack_public_path__ + "img/retroline.8b040129.jpg";